import React, { memo } from 'react'

/**
 * Optimierte ConstructionCard-Komponente mit React.memo
 * 
 * Verhindert unnötige Re-Renders für Bauprojekte.
 */
const ConstructionCard = memo(({ 
  project,
  onOpenModal
}) => {
  return (
    <div
      key={project.id}
      className="rounded-2xl bg-gradient-to-br from-slate-900/70 to-slate-800/60 border border-white/5 p-4"
    >
      <div className="flex justify-between items-center">
        <div>
          <p className="text-xs text-slate-500 uppercase">{project.lotLabel}</p>
          <h4 className="text-lg text-white font-semibold">{project.buildingLabel}</h4>
        </div>
        <span className="text-sm text-slate-300">{project.monthsRemaining} Monate</span>
      </div>
      <div className="mt-4">
        <div className="flex justify-between text-xs text-slate-500">
          <span>Baufortschritt</span>
          <span>{project.progress}%</span>
        </div>
        <div className="h-2 bg-slate-700 rounded-full overflow-hidden mt-2">
          <div
            className="h-full bg-gradient-to-r from-blue-500 to-blue-400 transition-all"
            style={{ width: `${project.progress}%` }}
          />
        </div>
      </div>
      {onOpenModal && (
        <button
          onClick={() => onOpenModal(project)}
          className="mt-4 w-full rounded-xl bg-blue-500/80 py-2 text-sm font-semibold text-white hover:bg-blue-500 transition"
        >
          Details anzeigen
        </button>
      )}
    </div>
  )
}, (prevProps, nextProps) => {
  // Custom comparison function
  return (
    prevProps.project.id === nextProps.project.id &&
    prevProps.project.progress === nextProps.project.progress &&
    prevProps.project.monthsRemaining === nextProps.project.monthsRemaining
  )
})

ConstructionCard.displayName = 'ConstructionCard'

export default ConstructionCard
